import { keysVsVal } from "@/utils";

const domain_en = keysVsVal(
  [
    // 英语域名
    "en-v-ls.comfortweather.com",
    // 美国
    "en-mxwg.comfortweather.com",
    // 小米天气的小部件英文域名
    "en-miwg.comfortweather.com",
    // 英语
    "en-mils.comfortweather.com",
    // 英语域名
    "en-wg.comfortweather.com",
    "mos.comfortweather.com",
    // 缅甸语
    "my-mils.comfortweather.com",
  ],
  "en",
);

const domain_th = keysVsVal(
  [
    // 泰语域名
    "th-v-ls.comfortweather.com",
    // 泰语
    "th-mils.comfortweather.com",
  ],
  "th",
);

const domain_id = keysVsVal(
  [
    // 印尼语域名
    "id-v-ls.comfortweather.com",
    // 小米印尼语域名
    "id-miwg.comfortweather.com",
    // 印尼语
    "id-mils.comfortweather.com",
    // 印尼语
    "id-wi.comfortweather.com",
    // 印尼语域名
    "id-wg.comfortweather.com",
  ],
  "id",
);

const domain_es = keysVsVal(
  [
    // 墨西哥
    "es-mxwg.comfortweather.com",
    // 西班牙语
    "es-mils.comfortweather.com",
    // 西班牙语
    "es-wi.comfortweather.com",
    // 西班牙语域名
    "es-wg.comfortweather.com",
  ],
  "es",
);

const domain_hi = keysVsVal(
  [
    // 印地语域名
    "hi-v-ls.comfortweather.com",
    // 小米印地语域名
    "hi-miwg.comfortweather.com",
    // 印地语域名
    "hi-wg.comfortweather.com",
  ],
  "hi",
);

const domain_vi = keysVsVal(
  [
    // 越南语域名
    "vi-v-ls.comfortweather.com",
    // 越南语
    "vi-mils.comfortweather.com",
  ],
  "vi",
);

const domain_pt = keysVsVal(
  [
    // 巴西葡萄牙语
    "pt-br-mils.comfortweather.com",
    // 巴西-葡萄牙
    "pt-br-wg.comfortweather.com",
  ],
  "pt",
);

const domain_pt_pt = keysVsVal(
  [
    // 欧洲-葡萄牙语
    "pt-mils.comfortweather.com",
  ],
  "pt-pt",
);

const domain_ar = keysVsVal(
  [
    // 阿拉伯语
    "arabic-mils.comfortweather.com",
  ],
  "ar",
);
const domain_tr_tr = keysVsVal(
  [
    // 土耳其语
    "tr-mils.comfortweather.com",
  ],
  "tr-tr",
);
const domain_fr_fr = keysVsVal(
  [
    // 法语
    "fr-mils.comfortweather.com",
  ],
  "fr-fr",
);
const domain_it_it = keysVsVal(
  [
    // 意大利语
    "it-mils.comfortweather.com",
  ],
  "it-it",
);
const domain_ur = keysVsVal(
  [
    // 乌尔都语
    "urdu-mils.comfortweather.com",
  ],
  "ur",
);
const domain_ja_jp = keysVsVal(
  [
    // 日语
    "jp-mils.comfortweather.com",
  ],
  "ja-jp",
);

const domain_de_de = keysVsVal(
  [
    // 德语
    "ger-mils.comfortweather.com",
  ],
  "de-de",
);

const domain_pl_pl = keysVsVal(
  [
    // 波兰语
    "po-mils.comfortweather.com",
  ],
  "pl-pl",
);

const domain_bn_bd = keysVsVal(
  [
    // 孟加拉语
    "bn-mils.comfortweather.com",
  ],
  "bn-bd",
);

const domain_el_gr = keysVsVal(
  [
    // 希腊语
    "el-mils.comfortweather.com",
  ],
  "el-gr",
);

const domain_he = keysVsVal(
  [
    // 希伯来语
    "he-mils.comfortweather.com",
  ],
  "he",
);
const domain_ko = keysVsVal(
  [
    // 韩语
    "ko-mils.comfortweather.com",
  ],
  "ko",
);
const domain_uk = keysVsVal(
  [
    // 乌克兰语
    "uk-mils.comfortweather.com",
  ],
  "uk",
);
const domain_ru_ru = keysVsVal(
  [
    // 俄语
    "ru-mils.comfortweather.com",
    // go机型新增单独俄罗斯的子域名
    "rs-miwg.comfortweather.com",
    //  小部件的俄罗斯域名新增域名
    "rs-wg.comfortweather.com",
    "rs-mils.comfortweather.com",
  ],
  "ru-ru",
);

const domain_az_latn_az = keysVsVal(
  [
    // 阿塞拜疆语
    "az-mils.comfortweather.com",
  ],
  "az-latn-az",
);

const domain_hu_hu = keysVsVal(
  [
    // 匈牙利语
    "hu-mils.comfortweather.com",
  ],
  "hu-hu",
);

const domain_ro_ro = keysVsVal(
  [
    // 罗马尼亚语
    "ro-mils.comfortweather.com",
  ],
  "ro-ro",
);

const domain_sr_rs = keysVsVal(
  [
    // 塞尔维亚语
    "sr-mils.comfortweather.com",
  ],
  "sr-rs",
);

const domain_bg = keysVsVal(
  [
    // 保加利亚语
    "bg-mils.comfortweather.com",
  ],
  "bg",
);
const domain_sk = keysVsVal(
  [
    // 斯洛伐克语
    "sk-mils.comfortweather.com",
  ],
  "sk",
);
const domain_zh_hant = keysVsVal(
  [
    // 繁体中文
    "zh-hant-mils.comfortweather.com",
  ],
  "zh-hant",
);
const domain_si = keysVsVal(
  [
    // 僧伽罗语
    "si-mils.comfortweather.com",
  ],
  "si",
);
const domain_cs = keysVsVal(
  [
    // 捷克语
    "cs-mils.comfortweather.com",
  ],
  "cs",
);

export default {
  ...domain_en,
  ...domain_th,
  ...domain_id,
  ...domain_es,
  ...domain_hi,
  ...domain_vi,
  ...domain_pt,
  ...domain_pt_pt,
  ...domain_ar,
  ...domain_tr_tr,
  ...domain_fr_fr,
  ...domain_it_it,
  ...domain_ur,
  ...domain_ja_jp,
  ...domain_de_de,
  ...domain_pl_pl,
  ...domain_bn_bd,
  ...domain_el_gr,
  ...domain_he,
  ...domain_ko,
  ...domain_uk,
  ...domain_ru_ru,
  ...domain_az_latn_az,
  ...domain_hu_hu,
  ...domain_ro_ro,
  ...domain_sr_rs,
  ...domain_bg,
  ...domain_sk,
  ...domain_zh_hant,
  ...domain_si,
  ...domain_cs,
};
